<template>
  <div class="content">
    <div class="hour-forecast">
      <div class="publish-time" v-if="showTime && giftData.ptimestemp">
<!--        <i class="el-icon-time"></i>-->
<!--        数据时间：{{ $moment(giftData.ptimestemp).format('YYYY-MM-DD HH:mm') }}-->
        <div>{{ $moment(giftData.ptimestemp).format('YYYY-MM-DD HH:mm') }}更新</div>
      </div>
      <div class="hour-forecast-wrap">
        <div class="hour-forecast-list" ref="hourForecastList">
          <div class="chart" :id="chartsId"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import echarts from '@/config/echarts/index.js'
import { getHourForecastOption } from '@/config/echarts/option/index.js'
import { mapState } from 'vuex'
import fa from 'element-ui/src/locale/lang/fa'
export default {
  // props: ['params', 'forecastType', 'cardEchart', 'showTime'],
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    forecastType: {
      type: Number,
      default: 0
    },
    cardEchart: {
      type: Boolean,
      default: false
    },
    showTime: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      charts: '',
      giftData: {},
      chartsId: ''
    }
  },
  created () {
    this.chartsId = this.cardEchart ? 'card-temp-chart' + Math.random() : 'temp-chart' + Math.random()
  },
  watch: {
    activeCountyId: {
      handler () {
        setTimeout(() => {
          this.getGiftData()
        }, 100)
      },
      immediate: true
    },
    forecastType () {
      this.resetEchart()
    },
    giftDataResult: {
      handler () {
        this.$nextTick(() => {
          this.getGiftData()
        })
      },
      deep: true
    }

  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId', 'giftDataResult'])
  },
  methods: {
    initEchart () {
      // 24小时预报温度曲线图
      const idName = this.chartsId
      console.log('idName', idName)
      const tempChart = echarts.init(document.getElementById(idName))
      tempChart.setOption(getHourForecastOption())
      this.charts = tempChart
      // 页面缩放
      window.onresize = () => {
        Vue.prototype.$rootFontSize = document.body.clientWidth / 1920 * 16
        document.getElementsByTagName('html')[0].style.fontSize = this.$rootFontSize + 'px'
        this.charts.resize()
      }

      tempChart.on('legendselectchanged', function (params) {
        const options = tempChart.getOption()
        if (params.selected['温度']) {
          options.yAxis[0].show = true
          options.yAxis[1].show = false
          options.yAxis[2].show = false
          options.grid.right = '10'
        }
        if (params.selected['雨量']) {
          options.yAxis[0].show = false
          options.yAxis[1].show = true
          options.yAxis[2].show = false
        }
        if (params.selected['风速']) {
          options.yAxis[0].show = false
          options.yAxis[1].show = false
          options.yAxis[2].show = true
        }
        tempChart.setOption(options)
        tempChart.resize()
      })

      this.$bus.$on('changeForest', (data) => {
        this.getGiftData(data)
      })

      this.$bus.$on('changeHourForestResize', () => {
        this.$nextTick(() => {
          this.charts.resize()
        })
      })

      this.$bus.$on('changeCardData', () => {
        this.$nextTick(() => {
          this.charts.resize()
        })
      })
    },
    // 获取gif预报
    async getGiftData (data) {
      if (!this.charts) {
        this.initEchart()
      }
      if (!this.giftDataResult.datedec) {
        return ''
      }
      const result = data || this.giftDataResult
      this.giftData = result
      const ptimestemp = result.ptimestemp
      const time = this.$moment(result.ptimestemp).format('HH')

      // 格式化滑动数据
      const nowTime = new Date().getTime()
      const timAarr = []
      let startTime = Date.now()

      let start = nowTime - time
      const hourTime = 1000 * 60 * 60
      if ((time === '08' && nowTime <= ptimestemp) || (time === '20' && nowTime <= ptimestemp)) {
        start = 0
        startTime = ptimestemp
      } else if ((time === '08' || time === '20') && nowTime > ptimestemp) {
        const diff = Math.floor((nowTime - ptimestemp) / hourTime)
        start = diff
        startTime = ptimestemp + diff * 3600000
      }

      for (let i = 0; i < 12; i++) {
        const step = i * 2 + 1
        const value = startTime + 3600000 * step
        const time = this.$moment(value).format('HH:00')
        timAarr.push(time)
      }
      let temp = this.giftData.gift_t.slice(start, start + 24)
      let hourrf = this.giftData.gift_rain.slice(start, start + 24)
      let windd = this.giftData.gift_windd.slice(start, start + 24)
      let winds = this.giftData.gift_winds.slice(start, start + 24)
      temp = temp.filter((item, index) => {
        if (index % 2 === 0) {
          return true
        }
      })
      hourrf = hourrf.filter((item, index) => {
        if (index % 2 === 0) {
          return true
        }
      })
      windd = windd.filter((item, index) => {
        if (index % 2 === 0) {
          return true
        }
      })
      winds = winds.filter((item, index) => {
        if (index % 2 === 0) {
          return true
        }
      })

      const excludes = [null, 'null']
      temp = temp.map(item => excludes.includes(item) ? '--' : item)
      hourrf = hourrf.map(item => excludes.includes(item) ? '--' : item)
      const option1 = getHourForecastOption()
      const hourForecastWidth = 27.9
      const hourForecastList = this.$refs.hourForecastList
      hourForecastList.style.width = hourForecastWidth * timAarr.length + 'px'
      option1.xAxis.data = timAarr
      option1.series[0].data = temp
      option1.series[1].data = hourrf
      option1.series[2].data = winds
      option1.series[2].symbolRotate = function (value, params) {
        if (windd[params.dataIndex] !== -999.9) {
          return 90 - windd[params.dataIndex] * 45
        }
        return 0
      }
      option1.yAxis[0].max = Math.floor(Math.max(...temp) + 2)
      option1.yAxis[0].min = Math.floor(Math.min(...temp) - 2)
      option1.yAxis[0].min = option1.yAxis[0].min - 2
      option1.yAxis[1].max = Math.floor(Math.max(...hourrf) + 1)
      if (option1.yAxis[1].max < 5) {
        option1.yAxis[1].max = 5.0
      }
      option1.yAxis[1].min = Math.floor(Math.min(...hourrf))

      option1.yAxis[2].max = Math.floor(Math.max(...winds) + 2)
      option1.yAxis[2].min = Math.floor(Math.min(...winds) - 2 < 0 ? 0 : Math.min(...winds) - 2)
      this.charts.clear()
      this.charts.setOption(option1)
      this.$nextTick(() => {
        this.charts.resize()
      })
    },

    resetEchart () {
      if (this.charts) {
        this.$nextTick(() => {
          this.charts.resize()
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.6vw 1.04vw 0.56vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  // pointer-events: none;

  .hour-forecast {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0vw;

    .hour-forecast-wrap {
      position: relative;
      // top: -2.04vw;
      width: 100%;
      margin-top: 0.52vw;
      //height: calc(100% - 0.52vw);
      overflow: hidden;
      min-height: 8.25rem;
      .hour-forecast-list {
        width: 100% !important;
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        transition: all 0.3s linear;
        .item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          width: 5.58rem;

          span {
            font-size: 0.75rem;
            color: #FFF;
          }

          .des {
            font-size: 0.88rem;
            color: #FFF;
          }

          img {
            width: 2.25rem;
          }

          .chart {
            height: 90%;
          }

          .wind {
            color: #FFF;
          }
        }

        .chart {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
        }
      }
    }

    .left-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/左.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      left: 1.2rem;
      cursor: pointer;
    }

    .right-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/右.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      right: 1.2rem;
      cursor: pointer;
    }
  }

  .days-forecast {
    height: 100%;
    // padding: 8% 3% 0 2%;
    box-sizing: border-box;

    .days-forecast-list {
      display: flex;
      justify-content: space-between;
      height: 100%;
      position: relative;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        width: 6.85rem;

        span {
          font-size: 0.85rem;
          color: #FFF;
        }

        font {
          font-size: 0.98rem;
          color: #FFF;
        }

        img {
          width: 2rem;
        }

        .chart {
          height: 50%;
        }
      }

      #high-low-temp-chart {
        position: absolute;
        left: 2.3rem;
        right: 2.3rem;
        top: 53%;
        height: 45%;
      }
    }
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: .8vw;
    ;
    color: #FFF;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}
</style>
